import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Dimensions,
  Text,
  VirtualizedList,
  Platform,
} from "react-native";

import {
  RecyclerListView,
  DataProvider,
  LayoutProvider,
} from "recyclerlistview";

import Utils, {
  hasItems,
  getStorageItem,
  getStorageKey,
  nowUserTz,
  isWeb,
  isAppleDevice,
  timeslotsEqual,
} from "../../../../helpers/utils";
import TimeSlotItem from "./TimeSlotItem";
import AppConfig from "../../../../config/AppConfig";

const USE_RECYCLER_LIST = false;

const { width: WIDTH, height: HEIGHT } = Dimensions.get("window");

export default function Timeslots(props) {
  const journalContext = props.journalContext;
  const { onRenderComplete = () => {} } = journalContext;

  const {
    title,
    selectedDate,
    controller,
    timeslots,
    showIcons,
    autoscroll = false,
  } = props;
  const [initialScrollIndex, setInitialScrollIndex] = useState(-1);
  const [timeslotsList, setTimeslotList] = useState([]);
  const [allowSetIndex, setAllowSetIndex] = useState(true);

  const source = props.source;

  //let listRef = null;
  const now = Utils.nowUserTz(controller);
  const today = now.format("YYYY-MM-DD");

  const keyExtractor = (item) => item.id;
  const currentDateTime = nowUserTz(this.controller);

  const renderItem = ({ item, index }) => {
    return (
      <TimeSlotItem
        key={"ts_" + source + "_" + item.time}
        journalContext={journalContext}
        prevTimeslot={
          index > 0 && timeslots?.length >= index ? timeslots[index - 1] : null
        }
        timeslot={item}
        nextTimeslot={
          index > 0 && timeslots?.length > index + 1
            ? timeslots[index + 1]
            : null
        }
        {...props}
        index={index}
        time={now}
        today={today}
        showIcons={showIcons}
        positionIndex={index}
        totalCount={timeslots?.length}
        showEndTime={index === timeslots.length - 1}
        currentDateTime={currentDateTime}
      />
    );
  };

  useEffect(() => {
    if (timeslotsEqual(timeslots, timeslotsList, selectedDate)) {
      onRenderComplete();
      return;
    }

    setTimeslotList(timeslots || []);
    if (allowSetIndex) {
      setInitialListIndex();
    }
  }, [timeslots]);

  const setInitialListIndex = () => {
    if (!autoscroll || !timeslots.length) return;

    getStorageItem(getStorageKey(controller, "CONFIRMATION_DATE")).then(
      (savedDateTime) => {
        setAllowSetIndex(false);

        let lastModifiedIndex = -1;
        let currentTimeIndex = -1;
        const now = Utils.nowUserTz(controller);
        const today = now.format("YYYY-MM-DD");
        timeslots.forEach((t, index) => {
          if (t.time.toString() === savedDateTime) lastModifiedIndex = index;
          if (Utils.getTimeIndex(today, now, t) >= 0) currentTimeIndex = index;
        });
        const realScrollIndex =
          lastModifiedIndex > -1
            ? lastModifiedIndex
            : currentTimeIndex > -1
            ? currentTimeIndex
            : 0;

        const offset = Math.round((HEIGHT - 300) / 100);
        const scrollToIndex = Math.max(0, realScrollIndex - offset);
        setInitialScrollIndex(scrollToIndex);
      },
    );
  };

  const onContentSizeChange = () => {
    onRenderComplete();

    /* if (false) {
      //disabled 2021.05 for scroll jump issues
      if (!autoscroll) return;
      if (
        listRef != null &&
        hasItems(timeslots) &&
        initialScrollIndex < timeslots.length
      ) {
        listRef.scrollToIndex({ index: initialScrollIndex, animated: false });
      }
    } */
  };

  const itemCount = (data) => (hasItems(timeslots) ? timeslots.length : 0);
  const getItemData = (data, index) => timeslots[index];

  const itemsToRender = props.isHomeCard ? 3 : 21;
  const renderPerBatch = props.isHomeCard ? 3 : 21;
  const windowSize = props.isHomeCard ? 3 : 21;

  const width = isWeb
    ? Math.min(WIDTH, AppConfig.MAX_WIDTH)
    : isAppleDevice
    ? WIDTH * 2
    : WIDTH;
  const dataProvider = USE_RECYCLER_LIST
    ? new DataProvider((r1, r2) => {
        return r1 !== r2;
      }).cloneWithRows(timeslotsList)
    : null;
  const layoutProvider = new LayoutProvider(
    () => 0,
    (type, dim) => {
      dim.width = width;
      dim.height = 41;
    },
  );
  
  const rowRenderer = (type, data, index) => {
    return renderItem({ item: data, index });
  };

  console.log(new Date().toISOString() + " Render timeslots");

  return (
    <View style={[styles.container, props.containerStyle]}>
      {title ? (
        <View style={styles.sectionHeader}>
          <Text style={styles.headerText}>{title}</Text>
        </View>
      ) : null}

      {/* Home page fix */}
      {hasItems(timeslots) && (!autoscroll || initialScrollIndex >= 0) ? (
        USE_RECYCLER_LIST ? (
          <RecyclerListView
            rowRenderer={rowRenderer}
            dataProvider={dataProvider}
            layoutProvider={layoutProvider}
            contentContainerStyle={[styles.listContainer, props.styles]}
            style={[styles.listStyle]}
            initialRenderIndex={props.isHomeCard ? null : initialScrollIndex}
            keyboardShouldPersistTaps="handled"
          />
        ) : (
          <VirtualizedList
            ref={(el) => (listRef = el)}
            removeClippedSubviews={itemCount > 20}
            initialNumToRender={itemsToRender}
            maxToRenderPerBatch={renderPerBatch}
            windowSize={windowSize}
            updateCellsBatchingPeriod={2500}
            keyboardShouldPersistTaps="handled"
            onContentSizeChange={onContentSizeChange}
            initialScrollIndex={props.isHomeCard ? null : initialScrollIndex}
            contentContainerStyle={[styles.listContainer, props.styles]}
            style={[styles.listStyle]}
            onScrollToIndexFailed={() => {}}
            data={timeslots}
            getItemCount={itemCount}
            getItem={getItemData}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            getItemLayout={(data, index) => ({
              offset: 50 * index,
              length: 50,
              index,
            })}
          />
        )
      ) : null}
      {!hasItems(timeslots) ? (
        <View style={styles.noDataContainer}>
          <Text style={styles.noDataFound}>No data available.</Text>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    maxHeight: HEIGHT - 160,
    minHeight: 210,
    paddingBottom: 20,
  },
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    paddingLeft: 14,
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    color: "#2D3142",
  },
  listStyle: {
   /*  ...Platform.select({
      web: {
        overflowY: "visible",
        overflowX: "visible",
      }
    }) */
  },
  listContainer: {
    height: "auto",
    display: "flex",
    position: "relative",
    width: "100%",
    paddingTop: 10,
    marginBottom: "auto",
    overflow: "visible",
  },
  noDataContainer: {
    backgroundColor: "white",
    height: 210,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  noDataFound: {
    width: "100%",
    textAlign: "center",
  },
});
